<template>
  <v-container>
    <v-card outlined>
      <v-card-title>Add a question passage</v-card-title>
      <v-form ref="passage_form">
        <v-card outlined class="mx-2 mb-2"
          ><v-text-field
            label="Title"
            v-model="title"
            class="mx-4"
          ></v-text-field
        ></v-card>
        <v-card outlined class="mx-2 mb-2"
          ><v-textarea
            label="Passage"
            v-model="passage"
            class="mx-4"
          ></v-textarea
        ></v-card>
        <v-card class="mx-2 mb-2 px-4" outlined>
          <v-file-input
            label="Click to select image"
            id="passage_fileItem"
            clearable
            v-model="file"
          ></v-file-input
        ></v-card>
        <v-container class="d-flex flex-row align-center justify-end">
          <div v-show="showWarning">
            <v-container
              class="d-flex align-center mr-4 ml-n1 justify-center"
              style="outline: lightgrey auto thin;"
              ><v-icon class="mr-2" color="red">mdi-alert</v-icon>Passage exists
              and adding will overwrite</v-container
            >
          </div>
          <v-btn
            @click="onAddPassage"
            class="ml-4 mr-2 mb-2 mt-1"
            color="primary"
            style="outline-style: auto"
            >Add passage</v-btn
          >
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import passages from "../mixins/passages";
import fileUtils from "../mixins/fileUtils";
export default {
  name: "AddPassage",
  mixins: [passages, fileUtils],
  data: () => ({ title: "", passage: "", file: null }),
  computed: {
    passageTitles() {
      return this.getPassages().map(x => x.title);
    },
    showWarning() {
      return this.passageTitles.includes(this.title);
    }
  },
  methods: {
    onAddPassage: function() {
      if (this.file)
        this.uploadFile(this.file, imgUrl => {
          this.submitPassage(imgUrl);
        });
      else this.submitPassage();
    },
    submitPassage: function(imgUrl = "") {
      let data = { title: this.title, passage: this.passage, imgUrl };
      this.addPassage(data);
      this.$refs.passage_form.reset();
    }
  }
};
</script>

<style scoped></style>
